import { createConfirmation } from "react-confirm";
import ChooseUserModal from "./ChooseUserModal";

export const showChooseUserModal = createConfirmation(ChooseUserModal);
